module.exports = __webpack_public_path__ + "assets/32fb888a38bec666c6b2b834bffe5d77.png";